import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { publicService } from '../services/api';

export default function RequestAccessPage() {
  const [form, setForm] = useState({
    first_name: '', last_name: '', email: '', company: '', country: '', message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  const [error, setError] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await publicService.submitAccessRequest(form);
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again or email us directly.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card auth-card--wide">
        <Link to="/" className="auth-back">← Back to home</Link>

        <div className="auth-brand">
          <span className="cpn-logo-mark">CPN</span>
          <div>
            <span className="auth-brand-name">CK Partner Network</span>
            <span className="auth-brand-sub">Cloud Kinetics</span>
          </div>
        </div>

        {submitted ? (
          <div className="auth-success">
            <div className="success-icon">✓</div>
            <h2>Request received</h2>
            <p>Thank you, <strong>{form.first_name}</strong>. The Cloud Kinetics team will review your request and send an invitation to <strong>{form.email}</strong>.</p>
            <Link to="/" className="landing-btn-primary" style={{ marginTop: '1.5rem', display: 'inline-block' }}>Back to home</Link>
          </div>
        ) : (
          <>
            <h2 className="auth-title">Request Partner Access</h2>
            <p className="auth-subtitle">Fill in your details and the CK team will send you an invitation.</p>

            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="auth-form-row">
                <div className="auth-field">
                  <label>First name *</label>
                  <input required value={form.first_name} onChange={e => set('first_name', e.target.value)} placeholder="Jane" />
                </div>
                <div className="auth-field">
                  <label>Last name *</label>
                  <input required value={form.last_name} onChange={e => set('last_name', e.target.value)} placeholder="Smith" />
                </div>
              </div>
              <div className="auth-field">
                <label>Work email *</label>
                <input required type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="jane@yourcompany.com" />
              </div>
              <div className="auth-form-row">
                <div className="auth-field">
                  <label>Company name *</label>
                  <input required value={form.company} onChange={e => set('company', e.target.value)} placeholder="Acme Pte Ltd" />
                </div>
                <div className="auth-field">
                  <label>Country *</label>
                  <select required value={form.country} onChange={e => set('country', e.target.value)}>
                    <option value="">Select country…</option>
                    {['Singapore','Malaysia','Indonesia','Thailand','Philippines','Vietnam','India','Australia','Other'].map(c => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="auth-field">
                <label>How do you plan to partner with CK? <span className="label-opt">(optional)</span></label>
                <textarea rows={3} value={form.message} onChange={e => set('message', e.target.value)} placeholder="e.g. Resell AWS services, refer enterprise customers for cloud migration…" />
              </div>

              {error && <div className="message error" style={{ marginBottom: '1rem' }}>{error}</div>}
              <button type="submit" className="auth-submit" disabled={submitting}>
                {submitting ? 'Submitting…' : 'Submit Request'}
              </button>

              <p className="auth-footer-note">
                Already have an account? <Link to="/login">Sign in →</Link>
              </p>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
